import { tw } from "@careinfo/tailwind";
import { useContext, useState } from "react";
import { NotificationContext } from "./context";
import { Notice, Notification } from "./Notification";
import Modal from "../NoticeModal";
import NoticePopup from "../NoticePopup";

export default () => {
  const { filteredNoticeList } = useContext(NotificationContext);
  const [isOpenNoticePopup, setOpenNoticePopup] = useState(false);
  const [noticeData, setNoticeData] = useState(null);
  const handleView = (item) => {
    setNoticeData(item);
    setOpenNoticePopup(true);
  };

  return (
    <>
      <div className={tw`relative space-y-2 flex-1 overflow-y-auto`}>
        {filteredNoticeList?.length > 0 ? (
          <>
            {filteredNoticeList?.map((item: Record<string, any>) => (
              <Notice key={item.id} item={item} handleView={handleView} />
            ))}
          </>
        ) : (
          <p className={tw`text-lg text-gray-500 font-medium text-center py-4`}>
            "No new notice"
          </p>
        )}
      </div>
      <Modal
        isOpen={isOpenNoticePopup}
        setIsOpen={setOpenNoticePopup}
        title={"Notice"}
      >
        <NoticePopup NoticeData={noticeData} />
      </Modal>
    </>
  );
};
